/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$( document ).ready(function() {
  var flkty = new Flickity('.Product__Slideshow');

  var testimonials = $('.Product__SlideshowNavScroller');
  testimonials.on( 'select.flickity', function( event , index ) {
     event.preventDefault();
    event.stopPropagation();
    var index2 =    $('.Product__SlideshowNav--thumbnails .flickity-slider').find('.is-selected').data('index');
    
    flkty.select( index2 );
  });
});

